import * as React from 'react';
import { FilterCommonProps } from '../types';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { OptionTypes, SubOptionTypes, FilterOption } from 'app/components/filters/types';
import { FilterOptionType } from 'app/area/filters/types';
import { RadioSymbol, CheckSymbol } from 'ui';
import { customFilterFieldPostfix } from '../../constants';

export interface FilterTextState {
  selectedSubOptions?: SubOptionTypes[];
}

export interface FilterTextProps extends FilterCommonProps {
  onFilterOptionType: (filterOption: FilterOption, filterOptionType: FilterOptionType) => void;
}

export class FilterText extends React.Component<FilterTextProps, FilterTextState> {

  constructor(props: FilterTextProps) {
    super(props);

    this.state = {
      selectedSubOptions: props.initialValue && props.initialValue[0]
        && props.initialValue[0].hasOwnProperty('subOptionTypes') ? props.initialValue[0].subOptionTypes : []
    };
  }

  public componentDidUpdate(prevProps: FilterTextProps) {
    if (this.props.filterDomain !== prevProps.filterDomain) {
      this.setDefaultSubOptionType();
    }
  }

  private setDefaultSubOptionType() {
    if (this.props.filterDomain.subOptionTypes && this.props.filterDomain.subOptionTypes.length === 0
      && ((this.props.filterDomain.initialValue && this.props.filterDomain.initialValue.length === 0)
        || !this.props.filterDomain.initialValue)) {

      this.setState({
        selectedSubOptions: []
      });
    }
  }

  private getSelectedSubOptions = () => {
    const { filterDomain: { optionType }} = this.props;
    let selectedSubOptions = this.state.selectedSubOptions;

    if (optionType === OptionTypes.NotSpecified) {
      selectedSubOptions = [];
    }

    return selectedSubOptions;
  };

  private handleOptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const selectedOption = Number(e.currentTarget.value);

    this.props.onFilterOptionType({
      id: this.props.filterDomain.id,
      type: selectedOption
    }, FilterOptionType.OPTION_TYPE);

    this.setState({
      selectedSubOptions: this.getSelectedSubOptions()
    });
  };

  private handleSubOptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const value = Number(e.currentTarget.value);
    const selectedSubOption = e.currentTarget.checked && value;
    const newSubTypes = Number.isInteger(selectedSubOption) ? [...this.state.selectedSubOptions, selectedSubOption]
      : this.state.selectedSubOptions.filter(item => !selectedSubOption && item !== value);

    this.props.onFilterOptionType({
      id: this.props.filterDomain.id,
      subOptionTypes: newSubTypes.length > 0 ? newSubTypes : undefined
    }, FilterOptionType.SUB_OPTION_TYPE);

    this.setState({
      selectedSubOptions: newSubTypes
    });
  };

  private renderMatchExact = () => {
    const { translation } = this.props;

    return <>
      <div className="form-check">
        <input
          id={`${this.props.filterDomain.id}-match-exact`}
          type="checkbox"
          className="form-check-input visuallyhidden"
          value={SubOptionTypes.MatchExact}
          checked={this.state.selectedSubOptions.some(type => type === SubOptionTypes.MatchExact)}
          onChange={this.handleSubOptionChange}
        />

        <label
          htmlFor={`${this.props.filterDomain.id}-match-exact`}
          className="form-check-label media">
          <CheckSymbol />
          {translation.filters_contains_word_exact}
        </label>
      </div>
    </>;
  };

  private renderContainsWords = () => {
    const { simpleFormComponent: SimpleForm, initialValue, filterDomain: { id: name, optionType }, translation } = this.props;
    const selected = optionType !== OptionTypes.NotSpecified;

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-contains-words`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.ContainsWords}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-contains-words`}
        className="form-check-label">
        <RadioSymbol />
        <b>{translation.filters_contains_word}</b>
      </label>

      {selected && <>
        {this.renderMatchExact()}
        <SimpleForm
          name={name}
          type={FIELD_TYPE.TEXTAREA}
          initialValue={initialValue && initialValue.length > 0 && initialValue[0].hasOwnProperty('value') ? initialValue[0].value : ''}
        /></>}
    </div>;
  };

  private renderNotSpecified = () => {
    const { simpleFormComponent, translation, filterDomain: { id: name, optionType } } = this.props;
    const SimpleForm = simpleFormComponent;
    const selected = optionType === OptionTypes.NotSpecified;

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-not-specified`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.NotSpecified}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-not-specified`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_not_specified_title}</b>
          <p>{translation.filters_not_specified_subtitle}</p>
        </div>
        {selected && <div className="d-none">
            <SimpleForm
              name={name + customFilterFieldPostfix.notSpecified}
              type={FIELD_TYPE.TEXTAREA}
              initialValue={translation.filters_not_specified_title}
            />
          </div>}
      </label>
    </div>;
  };

  public render() {
    return <>
      {this.renderContainsWords()}
      {this.renderNotSpecified()}
    </>;
  }
}
